import { openComponentInPopup, QueryParameter } from './common';
import { IPopup, PopupOptions } from './popup';

export default class ConfirmDialog {
    private onClickOk: () => void;
    private onClickCancel: () => void;
    private popup: IPopup;

    constructor(onClickOk: () => void, onClickCancel?: () => void) {
        this.onClickOk = onClickOk;
        this.onClickCancel = onClickCancel;
    }

    async open(queryParam: QueryParameter[] = null): Promise<void> {
        this.popup = await openComponentInPopup('ConfirmDialog', queryParam, <
            PopupOptions
        >{ id: 'confirm-popup' });
        this.subscribeOkButton();
        this.subscribeCancelButton();
    }

    private subscribeOkButton(): void {
        document
            .querySelector('[data-component=ConfirmDialog] [data-option=true]')
            .addEventListener('click', () => {
                typeof this.onClickOk === 'function' && this.onClickOk();
                this.popup.close();
            });
    }

    private subscribeCancelButton(): void {
        document
            .querySelector('[data-component=ConfirmDialog] [data-option=false]')
            .addEventListener('click', () => {
                typeof this.onClickCancel === 'function' &&
                    this.onClickCancel();
                this.popup.close();
            });
    }
}
